export default __webpack_public_path__ + "static/9_15-665ba908f154aa99d0085767a5ed679d.png";